export const isPatentFilled = (p) => {
  if (!p) return false;
  const hasId = p.patentId && p.patentId.toString().trim() !== "";
  const hasTitle = p.title && p.title.toString().trim() !== "";
  const hasLink = p.link && p.link.toString().trim() !== "";
  return hasId && hasTitle && hasLink;
};

export const filledPatentsFrom = (data) =>
  data && data.patents ? (data.patents || []).filter(isPatentFilled) : [];
